import react from "react";
import { call, put } from "redux-saga/effects";
import { setSteps } from "../../slices/step/stepSlice";
import { requestGetAllSteps, requestSaveSteps } from "../requests/step";

export function* handleSaveSteps(action) {
  try {
    yield call(requestSaveSteps(action));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetAllSteps(action) {
  try {
    const response = yield call(requestGetAllSteps, action);
    const assemblysteps = response.data.map((step) => {
      const elements = step.element;
      const steps = step.step;
      const combinedWithSteps = Object.assign(elements, { step: steps });
      return combinedWithSteps;
    });
    yield put(setSteps(assemblysteps));
  } catch (error) {
    if (error.response) {
      yield put(setSteps(null));
    }
  }
}

export function* handleSetSteps(action) {
  try {
    yield put(setSteps({ action }));
  } catch (error) {}
}

// export function* handleAddStep(action) {
//   // try {
//   //   yield call(requestAddStep(action));
//   // } catch (error) {
//   //   console.log(error);
//   // }
// }
